module.exports = __webpack_public_path__ + "static/media/400019_01.ab32fba6.png";